var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-outline-dark btn-sm w-100",
        on: { click: _vm.showConfirmationModal },
      },
      [
        _vm._v(
          "\n    " + _vm._s(_vm._f("translate")("Cancel subscription")) + "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "confirmationModal",
        staticClass: "modal fade",
        attrs: {
          id: "confirmation",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "span",
                {
                  staticClass: "modal-title",
                  attrs: { id: "confirmationLabel" },
                },
                [_vm._v(_vm._s(_vm._f("translate")("Are you sure?")))]
              ),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body text-start" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("translate")(_vm.explanationText)) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-dark btn-sm px-3",
                  attrs: { type: "button", "data-bs-dismiss": "modal" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("Cancel")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-dark btn-sm px-3",
                  attrs: { type: "button" },
                  on: { click: _vm.cancelSubscription },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("Cancel subscription")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "surveyModal",
        staticClass: "modal fade",
        attrs: {
          id: "surveyModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "surveyModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "span",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "surveyModalLabel" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("translate")("Subscription has been canceled")
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body text-start" }, [
                _c("p", { staticClass: "small" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm._f("translate")(
                          "We're sorry to see you leave. Please help us improve the platform by stating the reason why your subscription has ended"
                        )
                      ) +
                      ".\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group mb-4" },
                  [
                    _c("label", { staticClass: "form-label small fw-medium" }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("Why are you canceling?"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.options, function (o) {
                      return _c("div", { key: o.key, staticClass: "mb-2" }, [
                        _c("div", {}, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.reason,
                                  expression: "reason",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "cancelationReason",
                                id: o.key,
                              },
                              domProps: {
                                value: o.key,
                                checked: _vm._q(_vm.reason, o.key),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.reason = o.key
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label small fw-medium",
                                attrs: { for: o.key },
                              },
                              [_vm._v(_vm._s(_vm.$t(`my.${o.key}`)))]
                            ),
                          ]),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    ["other", "technical"].includes(_vm.reason)
                      ? _c("div", { staticClass: "mt-2" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.other_reason,
                                expression: "other_reason",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "other-reason",
                              rows: "3",
                              placeholder:
                                _vm.$t("Can you tell us what happened") + "...",
                            },
                            domProps: { value: _vm.other_reason },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.other_reason = $event.target.value
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label small fw-medium" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("translate")(
                            "Would you consider returning in the future?"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.returnIntentOptions, function (intent) {
                      return _c(
                        "div",
                        { key: intent.key, staticClass: "mb-2" },
                        [
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.return_intent,
                                  expression: "return_intent",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "returnIntent",
                                id: intent.key,
                              },
                              domProps: {
                                value: intent.key,
                                checked: _vm._q(_vm.return_intent, intent.key),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.return_intent = intent.key
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label small fw-medium",
                                attrs: { for: intent.key },
                              },
                              [_vm._v(_vm._s(_vm.$t(`my.${intent.key}`)))]
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-dark btn-sm px-3",
                    attrs: {
                      type: "button",
                      disabled: !_vm.valid_reason || _vm.locked,
                    },
                    on: { click: _vm.sendSurvey },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("translate")("Submit")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }